import lodash from "lodash";
import { dynamicFeat, initializeTabData, repopulate } from "./PropertyDescriptionUtils";

// TYPES

export const AI_DESC_PD_UPDATE_PROP_TYPE = "AI_DESC_PD_UPDATE_PROP_TYPE";
export const AI_DESC_PD_ADD_PROP_FEAT = "AI_DESC_PD_ADD_PROP_FEAT";
export const AI_DESC_PD_REMOVE_PROP_FEAT = "AI_DESC_PD_REMOVE_PROP_FEAT";
export const AI_DESC_PD_HANDLE_REPOPULATE_PD =
    "AI_DESC_PD_HANDLE_REPOPULATE_PD";
export const AI_DESC_PD_HANDLE_UPDATE_DESC_TYPE =
    "AI_DESC_PD_HANDLE_UPDATE_DESC_TYPE";
export const AI_DESC_PD_UPDATE_PROP_ATT = "AI_DESC_PD_UPDATE_PROP_ATT";
export const AI_DESC_PD_UPDATE_PROP_ATT_DD_STATE =
    "AI_DESC_PD_UPDATE_PROP_ATT_DD_STATE";
export const AI_DESC_PD_UPDATE_PROP_ATT_DD_SELECT =
    "AI_DESC_PD_UPDATE_PROP_ATT_DD_SELECT";
export const AI_DESC_PD_UPDATE_DESC = "AI_DESC_PD_UPDATE_DESC";
export const AI_DESC_PD_HANDLE_ACTION_DESC = "AI_DESC_PD_HANDLE_ACTION_DESC";
export const AI_DESC_PD_UPDATE_ACTION_DESC = "AI_DESC_PD_UPDATE_ACTION_DESC";
export const AI_DESC_PD_GENERATE_DESC = "AI_DESC_PD_GENERATE_DESC";
export const AI_DESC_PD_UNDO_DESC = "AI_DESC_PD_UNDO_DESC";
export const AI_DESC_PD_REGENERATE_DESC = "AI_DESC_PD_REGENERATE_DESC";
export const AI_DESC_PD_FETCH_DESC = "AI_DESC_PD_FETCH_DESC";
export const AI_DESC_PD_UPDATE_DESC_ISEDITING =
    "AI_DESC_PD_UPDATE_DESC_ISEDITING";
export const AI_DESC_PD_UPDATE_PROP_ADDRESS = "AI_DESC_PD_UPDATE_PROP_ADDRESS";
export const AI_DESC_PD_SELECT_PROP_ADDRESS = "AI_DESC_PD_SELECT_PROP_ADDRESS";
export const AI_DESC_PD_UPDATE_NEARBY_AMMENITIES =
    "AI_DESC_PD_UPDATE_NEARBY_AMMENITIES";
export const AI_DESC_PD_FETCH_NEARBY_AMMENITIES =
    "AI_DESC_PD_FETCH_NEARBY_AMMENITIES";
export const AI_DESC_PD_UPDATE_OTHER_NEARBY_AMMENITIES =
    "AI_DESC_PD_UPDATE_OTHER_NEARBY_AMMENITIES";
export const AI_DESC_PD_SHOW_OTHER_NEARBY_AMMENITIES_INPUT_FIELD =
    "AI_DESC_PD_SHOW_OTHER_NEARBY_AMMENITIES_INPUT_FIELD";
export const AI_DESC_PD_FETCH_OTHER_NEARBY_AMMENITIES =
    "AI_DESC_PD_FETCH_OTHER_NEARBY_AMMENITIES";
export const AI_DESC_PD_UPDATE_DESIGN_TYPE = "AI_DESC_PD_UPDATE_DESIGN_TYPE";
export const AI_DESC_PD_HANDLE_TOP_DROPDOWN_OPEN =
    "AI_DESC_PD_HANDLE_TOP_DROPDOWN_OPEN";
export const AI_DESC_PD_UPDATE_PAGE_TYPE = "AI_DESC_PD_UPDATE_PAGE_TYPE";
export const AI_DESC_PD_UPDATE_TAB = "AI_DESC_PD_UPDATE_TAB";
export const AI_DESC_PD_UPDATE_TAB_DATA = "AI_DESC_PD_UPDATE_TAB_DATA";
export const AI_DESC_PD_CLEAR_PROP_DETAILS = "AI_DESC_PD_CLEAR_PROP_DETAILS";
export const AI_DESC_PD_HANDLE_SEVER_BUSY_POPUP =
    "AI_DESC_PD_HANDLE_SEVER_BUSY_POPUP";

// ACTIONS

export const updatePropType = (payload) => ({
    type: AI_DESC_PD_UPDATE_PROP_TYPE,
    payload,
});

export const addPropFeat = (payload) => ({
    type: AI_DESC_PD_ADD_PROP_FEAT,
    payload,
});

export const removePropFeat = (payload) => ({
    type: AI_DESC_PD_REMOVE_PROP_FEAT,
    payload,
});

export const updatePropAtt = (payload) => ({
    type: AI_DESC_PD_UPDATE_PROP_ATT,
    payload,
});

export const updatePropAttDdState = (payload) => ({
    type: AI_DESC_PD_UPDATE_PROP_ATT_DD_STATE,
    payload,
});

export const updatePropAttDdSelect = (payload) => ({
    type: AI_DESC_PD_UPDATE_PROP_ATT_DD_SELECT,
    payload,
});

export const updatePdDesc = (payload) => ({
    type: AI_DESC_PD_UPDATE_DESC,
    payload,
});

export const fetchPdDesc = (payload) => ({
    type: AI_DESC_PD_FETCH_DESC,
    payload,
});

export const updatePdDescIsEditing = (payload) => ({
    type: AI_DESC_PD_UPDATE_DESC_ISEDITING,
    payload,
});

export const updatePdPageType = (payload) => ({
    type: AI_DESC_PD_UPDATE_PAGE_TYPE,
    payload,
});

export const updatePdTab = (payload) => ({
    type: AI_DESC_PD_UPDATE_TAB,
    payload,
});

export const updatePdTabData = (payload) => ({
    type: AI_DESC_PD_UPDATE_TAB_DATA,
    payload,
});

export const updatePropAdd = (payload) => ({
    type: AI_DESC_PD_UPDATE_PROP_ADDRESS,
    payload,
});

export const selectPropAdd = (payload) => ({
    type: AI_DESC_PD_SELECT_PROP_ADDRESS,
    payload,
});

export const updateDesignType = (payload) => ({
    type: AI_DESC_PD_UPDATE_DESIGN_TYPE,
    payload,
});

export const handleTopDdOpen = (payload) => ({
    type: AI_DESC_PD_HANDLE_TOP_DROPDOWN_OPEN,
    payload,
});

export const fetchNearByAmmenities = (payload) => ({
    type: AI_DESC_PD_FETCH_NEARBY_AMMENITIES,
    payload,
});

export const updateNearByAmmenities = (payload) => ({
    type: AI_DESC_PD_UPDATE_NEARBY_AMMENITIES,
    payload,
});

export const fetchOtherNearByAmmenities = (payload) => ({
    type: AI_DESC_PD_FETCH_OTHER_NEARBY_AMMENITIES,
    payload,
});

export const updateOtherNearByAmmenities = (payload) => ({
    type: AI_DESC_PD_UPDATE_OTHER_NEARBY_AMMENITIES,
    payload,
});

export const showOtherNearByAmmenitiesInputField = (payload) => ({
    type: AI_DESC_PD_SHOW_OTHER_NEARBY_AMMENITIES_INPUT_FIELD,
    payload,
});

export const handlePdDescUndo = (payload) => ({
    type: AI_DESC_PD_UNDO_DESC,
    payload,
});

export const updateActionPdDesc = (payload) => ({
    type: AI_DESC_PD_UPDATE_ACTION_DESC,
    payload,
});

export const handleRepopulatePd = (payload) => ({
    type: AI_DESC_PD_HANDLE_REPOPULATE_PD,
    payload,
});

export const handleupdateDescType = (payload) => ({
    type: AI_DESC_PD_HANDLE_UPDATE_DESC_TYPE,
    payload,
});

export const clearPropertyDetails = (payload) => ({
    type: AI_DESC_PD_CLEAR_PROP_DETAILS,
    payload,
});

export const handlePdSeverBusyPopup = (payload) => ({
    type: AI_DESC_PD_HANDLE_SEVER_BUSY_POPUP,
    payload,
});
// Actions to trigger saga generators

export const generatePdDesc = (payload) => ({
    type: AI_DESC_PD_GENERATE_DESC,
    payload,
});

export const regeneratePdDesc = (payload) => ({
    type: AI_DESC_PD_REGENERATE_DESC,
    payload,
});

export const handleActionPdDesc = (payload) => ({
    type: AI_DESC_PD_HANDLE_ACTION_DESC,
    payload,
});

// REDUCER

export const INITIAL_STATE = {
    order_id: `${Date.now() + Math.floor(Math.random() * 100)}`,
    stepper: {
        steps: [
            {
                title: "Address & nearby amenities",
                active: true,
                completed: false,
            },
            {
                title: "Property details",
                active: false,
                completed: false,
            },
            { title: "Property features", active: false, completed: false },
            { title: "Description", active: false, completed: false },
        ],
        activeStep: "Address & nearby amenities",
        activeStepNo: 0,
    },
    "Property Address": "",
    isAmenitiesLoading: false,
    "Nearby Amenities": {},
    "Other Nearby Amenities": {},
    isOtherNbaInputVisible: false,
    "Property Details": {
        tabs: {
            tabOptions: ["Home interior", "General features"],
            activeTab: "Home interior",
            tabData: {},
        },
        descriptionType: {
            types: [
                "General comprehensive description",
                "Floor-wise description",
            ],
            selectedDescType: "General comprehensive description",
        },
        "Property type": {
            title: "Select property type",
            defaultTitle: "Select property type",
            dropDownList: [
                "Select property type",
                "Single-family",
                "Multi-family",
                "Condo",
                "Villa",
                "Townhouse",
                "Co-op",
                "Apartment",
                "Bungalow",
                "Weatherboard",
                "Lifestyle",
            ],
            isOpen: false,
            selectedItem: "",
        },
        "Design type": {
            title: "Select design",
            defaultTitle: "Select design",
            isOpen: false,
            dropDownList: [
                "Select design",
                "Transitional",
                "Modern",
                "Eclectic",
                "Contemporary",
                "Minimalist",
                "Mid Century Modern",
                "Bohemian",
                "Traditional",
                "Modern Farmhouse",
                "Shabby Chic",
                "Coastal",
                "Hollywood Glam",
                "Southwestern",
                "Rustic",
                "Industrial",
                "French Country",
                "Scandinavian",
                "Mediterranean",
                "Art Deco",
                "Asian Zen",
                "Japandi",
                "Country House",
                "Midcentury",
                "Bauhaus",
            ],
            selectedItem: "",
        },
        "Property Attributes": {
            "Number of Bedrooms": {
                lable: "Number of bedrooms",
                isRequired: true,
                value: "",
                placeHolder: "04",
                inputType: "dropDown",
                isDropdownAvailable: false,
                isFloatAllowed: false,
                ddObj: {
                    title: "04",
                    defaultTitle: "04",
                    dropDownList: [
                        "01",
                        "02",
                        "03",
                        "04",
                        "05",
                        "06",
                        "07",
                        "08",
                        "09",
                    ],
                    selectedItem: "",
                    isOpen: false,
                },
            },
            "Number of Bathrooms": {
                lable: "Number of bathrooms",
                isRequired: true,
                value: "",
                placeHolder: "04",
                inputType: "dropDown",
                isDropdownAvailable: false,
                isFloatAllowed: true,
                ddObj: {
                    title: "2.5",
                    defaultTitle: "2.5",
                    dropDownList: [
                        1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5,
                        8, 8.5, 9,
                    ],
                    selectedItem: "",
                    isOpen: false,
                },
            },
            Floors: {
                lable: "Floors",
                isRequired: true,
                value: "",
                placeHolder: "01",
                inputType: "dropDown",
                isDropdownAvailable: false,
                isFloatAllowed: false,
                ddObj: {
                    title: "02",
                    defaultTitle: "02",
                    dropDownList: ["01", "02", "03", "04", "05"],
                    selectedItem: "",
                    isOpen: false,
                },
            },
            "Floor area(sq ft)": {
                lable: "Floor area (sqft)",
                isRequired: true,
                value: "",
                placeHolder: "2500",
                inputType: "number",
                isDropdownAvailable: false,
                isFloatAllowed: false,
                dropdownContent: {
                    "Sq Feet": {
                        lable: "Sq Feet",
                        isSelected: true,
                    },
                    "Sq Meter": {
                        lable: "Sq Meter",
                        isSelected: false,
                    },
                },
                isOpen: false,
                unit: "Sq Feet",
            },
            "Lot size(sq ft)": {
                lable: "Lot size (sqft)",
                isRequired: false,
                value: "",
                placeHolder: "2500",
                inputType: "number",
                isDropdownAvailable: false,
                isFloatAllowed: false,
                dropdownContent: {
                    "Sq Feet": {
                        lable: "Sq Feet",
                        isSelected: true,
                    },
                    "Sq Meter": {
                        lable: "Sq Meter",
                        isSelected: false,
                    },
                },
                isOpen: false,
                unit: "Sq Feet",
            },
            Garage: {
                lable: "Garage",
                isRequired: false,
                value: "",
                placeHolder: "01 car",
                inputType: "dropDown",
                isDropdownAvailable: true,
                isFloatAllowed: false,
                dropdownContent: {
                    Type: {
                        lable: "Type",
                        isSelected: false,
                    },
                    Attached: {
                        lable: "Attached",
                        isSelected: false,
                    },
                    Detached: {
                        lable: "Detached",
                        isSelected: false,
                    },
                    Open: {
                        lable: "Open",
                        isSelected: false,
                    },
                },
                isOpen: false,
                unit: "",
                ddObj: {
                    title: "Number of cars",
                    defaultTitle: "Number of cars",
                    dropDownList: [
                        "Number of cars",
                        "01 car",
                        "02 cars",
                        "03 cars",
                        "04 cars",
                        "05 cars",
                    ],
                    selectedItem: "",
                    isOpen: false,
                },
            },
        },
        "Amazing features": {
            mostSalebleFeatures: {
                title: "",
                features: {
                    "MostSaleble Features": {
                        title: "The most saleable features include",
                        preDeterminedFeatures: [
                            {
                                featureName: "open floor plan",
                                isSelected: false,
                            },
                            {
                                featureName: "south facing roof",
                                isSelected: false,
                            },
                            {
                                featureName: "south facing windows",
                                isSelected: false,
                            },
                            {
                                featureName: "large backyard",
                                isSelected: false,
                            },
                            {
                                featureName: "jacuzzi",
                                isSelected: false,
                            },
                            {
                                featureName: "balcony in the primary bedroom",
                                isSelected: false,
                            },
                            {
                                featureName: "solar panel",
                                isSelected: false,
                            },
                            {
                                featureName: "high ceiling",
                                isSelected: false,
                            },
                            {
                                featureName: "new roof",
                                isSelected: false,
                            },
                            {
                                featureName: "lake view",
                                isSelected: false,
                            },
                            {
                                featureName: "upgraded bath",
                                isSelected: false,
                            },
                            {
                                featureName: "upgraded kitchen",
                                isSelected: false,
                            },
                            {
                                featureName: "scenic landscape view",
                                isSelected: false,
                            },
                            {
                                featureName: "city skyline view",
                                isSelected: false,
                            },
                            {
                                featureName: "mountain view",
                                isSelected: false,
                            },
                            {
                                featureName: "foyer",
                                isSelected: false,
                            },
                            {
                                featureName: "tankless water heater",
                                isSelected: false,
                            },
                            {
                                featureName: "swimming pool",
                                isSelected: false,
                            },
                            // {
                            //     featureName: "a lawned garden",
                            //     isSelected: false,
                            // },
                            // {
                            //     featureName: "separate shower cubicles",
                            //     isSelected: false,
                            // },
                        ],
                        selectedFeatures: "",
                        isRequired: true,
                    },
                },
            },
        },
        "Property features": {
            primaryBedroom: {
                title: "Primary Bedroom",
                features: {
                    "Bedroom Features": {
                        title: "The primary bedroom has features like",
                        preDeterminedFeatures: [
                            {
                                featureName: "built-in closets",
                                isSelected: false,
                            },
                            {
                                featureName: "carpeted flooring",
                                isSelected: false,
                            },
                            {
                                featureName: "en-suite bathroom",
                                isSelected: false,
                            },
                            {
                                featureName: "a walk-in closet",
                                isSelected: false,
                            },
                            {
                                featureName: "located on ground floor",
                                isSelected: false,
                            },
                            {
                                featureName: "wooden flooring",
                                isSelected: false,
                            },
                            {
                                featureName: "natural light",
                                isSelected: false,
                            },
                            {
                                featureName: "fire place",
                                isSelected: false,
                            },
                            {
                                featureName: "high ceiling",
                                isSelected: false,
                            },
                            {
                                featureName: "office",
                                isSelected: false,
                            },
                        ],
                        selectedFeatures: "",
                        isRequired: false,
                    },
                },
            },
            otherBedrooms: {
                title: "Other Bedrooms",
                features: {
                    "Other Bedrooms": {
                        title: "Other bedrooms have features like",
                        preDeterminedFeatures: [
                            {
                                featureName: "large windows",
                                isSelected: false,
                            },
                            {
                                featureName: "balcony",
                                isSelected: false,
                            },
                            {
                                featureName: "built-in closets",
                                isSelected: false,
                            },
                            {
                                featureName: "en-suite bathroom",
                                isSelected: false,
                            },
                            {
                                featureName: "a walk-in closet",
                                isSelected: false,
                            },
                            {
                                featureName: "fire place",
                                isSelected: false,
                            },
                            {
                                featureName: "wooden flooring",
                                isSelected: false,
                            },
                            {
                                featureName: "carpeted flooring",
                                isSelected: false,
                            },
                            {
                                featureName: "high ceiling",
                                isSelected: false,
                            },
                            {
                                featureName: "vaulted ceiling",
                                isSelected: false,
                            },
                        ],
                        selectedFeatures: "",
                        isRequired: false,
                    },
                },
            },
            livingRoom: {
                title: "Living Room",
                features: {
                    "Living Room": {
                        title: "The living room has features like",
                        preDeterminedFeatures: [
                            {
                                featureName: "large window",
                                isSelected: false,
                            },
                            {
                                featureName: "marble flooring",
                                isSelected: false,
                            },
                            {
                                featureName: "hardwood flooring",
                                isSelected: false,
                            },
                            {
                                featureName: "tiled flooring",
                                isSelected: false,
                            },
                            {
                                featureName: "fire place",
                                isSelected: false,
                            },
                            {
                                featureName: "natural light",
                                isSelected: false,
                            },
                            {
                                featureName: "high ceiling",
                                isSelected: false,
                            },
                            {
                                featureName: "vaulted ceiling",
                                isSelected: false,
                            },
                            {
                                featureName: "deck attached",
                                isSelected: false,
                            },
                            {
                                featureName: "sky light",
                                isSelected: false,
                            },
                        ],
                        selectedFeatures: "",
                        isRequired: false,
                    },
                },
            },
            kitchen: {
                title: "Kitchen",
                features: {
                    Kitchen: {
                        title: "The kitchen has features like",
                        preDeterminedFeatures: [
                            {
                                featureName: "kitchen islands",
                                isSelected: false,
                            },
                            {
                                featureName: "steel appliances",
                                isSelected: false,
                            },
                            {
                                featureName: "granite countertop",
                                isSelected: false,
                            },
                            {
                                featureName: "bar area",
                                isSelected: false,
                            },
                            {
                                featureName: "multiple sink",
                                isSelected: false,
                            },
                            {
                                featureName: "marble countertop",
                                isSelected: false,
                            },
                            {
                                featureName: "decorative backsplash",
                                isSelected: false,
                            },
                            {
                                featureName: "wooden cabinet",
                                isSelected: false,
                            },
                            {
                                featureName: "eat-in counter",
                                isSelected: false,
                            },
                        ],
                        selectedFeatures: "",
                        isRequired: false,
                    },
                },
            },
            bathroom: {
                title: "Bathroom",
                features: {
                    Bathroom: {
                        title: "The bathroom has features like",
                        preDeterminedFeatures: [
                            {
                                featureName: "granite countertop",
                                isSelected: false,
                            },
                            {
                                featureName: "modern vanity",
                                isSelected: false,
                            },
                            {
                                featureName: "double sink",
                                isSelected: false,
                            },
                            {
                                featureName: "built-in shelving",
                                isSelected: false,
                            },
                            {
                                featureName: "rain showerhead",
                                isSelected: false,
                            },
                            {
                                featureName: "glass door",
                                isSelected: false,
                            },
                            {
                                featureName: "radiant floor heating",
                                isSelected: false,
                            },
                            {
                                featureName: "sauna",
                                isSelected: false,
                            },
                            {
                                featureName: "marble floor",
                                isSelected: false,
                            },
                            {
                                featureName: "bathtub",
                                isSelected: false,
                            },
                        ],
                        selectedFeatures: "",
                        isRequired: false,
                    },
                },
            },
        },
        "General features": {
            homeExterior: {
                title: "Home exterior",
                features: {
                    "Home exterior": {
                        title: "The home exterior has features like",
                        preDeterminedFeatures: [
                            {
                                featureName: "backyard oasis",
                                isSelected: false,
                            },
                            {
                                featureName: "lush landscaping",
                                isSelected: false,
                            },
                            {
                                featureName: "private patio",
                                isSelected: false,
                            },
                            {
                                featureName: "front porch",
                                isSelected: false,
                            },
                            {
                                featureName: "gated pool",
                                isSelected: false,
                            },
                            {
                                featureName: "fresh paint",
                                isSelected: false,
                            },
                            {
                                featureName: "curb appeal",
                                isSelected: false,
                            },
                            {
                                featureName: "front yard",
                                isSelected: false,
                            },
                            {
                                featureName: "barbeque",
                                isSelected: false,
                            },
                            {
                                featureName: "outdoor kitchen",
                                isSelected: false,
                            },
                        ],
                        selectedFeatures: "",
                        isRequired: false,
                    },
                },
            },
            neighborhood: {
                title: "Neighborhood",
                features: {
                    Neighborhood: {
                        title: "The neighborhood has features like",
                        preDeterminedFeatures: [
                            {
                                featureName: "sidewalks",
                                isSelected: false,
                            },
                            {
                                featureName: "end of street",
                                isSelected: false,
                            },
                            {
                                featureName: "safe crosswalks",
                                isSelected: false,
                            },
                            {
                                featureName: "street parking",
                                isSelected: false,
                            },
                            {
                                featureName: "nearby public transportation",
                                isSelected: false,
                            },
                            {
                                featureName: "nearby restaurants",
                                isSelected: false,
                            },
                            {
                                featureName: "tree lined",
                                isSelected: false,
                            },
                            {
                                featureName: "well-maintained roads",
                                isSelected: false,
                            },
                        ],
                        selectedFeatures: "",
                        isRequired: false,
                    },
                },
            },
            smartFeatures: {
                title: "Smart features",
                features: {
                    "Smart features": {
                        title: "The smart features include",
                        preDeterminedFeatures: [
                            {
                                featureName: "smart lighting system",
                                isSelected: false,
                            },
                            {
                                featureName: "smart doorbells",
                                isSelected: false,
                            },
                            {
                                featureName: "smart sound system",
                                isSelected: false,
                            },
                            {
                                featureName: "smart outlet",
                                isSelected: false,
                            },
                            {
                                featureName: "smart sprinklers",
                                isSelected: false,
                            },
                            {
                                featureName: "smart locks",
                                isSelected: false,
                            },
                            {
                                featureName: "smart security cameras",
                                isSelected: false,
                            },
                            {
                                featureName: "smart smoke detectors",
                                isSelected: false,
                            },
                        ],
                        selectedFeatures: "",
                        isRequired: false,
                    },
                },
            },
            additionalRooms: {
                title: "Additional Rooms",
                features: {
                    "Additional Rooms": {
                        title: "The property also has ",
                        preDeterminedFeatures: [
                            {
                                featureName: "laundry room",
                                isSelected: false,
                            },
                            {
                                featureName: "gym room",
                                isSelected: false,
                            },
                            {
                                featureName: "basement",
                                isSelected: false,
                            },
                            {
                                featureName: "media room",
                                isSelected: false,
                            },
                            {
                                featureName: "store room",
                                isSelected: false,
                            },
                            {
                                featureName: "attic",
                                isSelected: false,
                            },
                            {
                                featureName: "study room",
                                isSelected: false,
                            },
                            {
                                featureName: "mud room",
                                isSelected: false,
                            },
                            {
                                featureName: "home office",
                                isSelected: false,
                            },
                            {
                                featureName: "sunroom",
                                isSelected: false,
                            },
                            {
                                featureName: "separated family room",
                                isSelected: false,
                            },
                            {
                                featureName: "guest room",
                                isSelected: false,
                            },
                        ],
                        selectedFeatures: "",
                        isRequired: false,
                    },
                },
            },
        },
        descriptionGenerated: [
            // {
            //     status: "Just now",
            //     description_generated:
            //         "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
            //     editedDesc: "",
            //     isEditing: false,
            //     isEdited: false,
            //     liked: null,
            //     generated_at: "",
            // },
        ],
        isGenDescBtnDisabled: true,
        isGenDescBtnHidden: false,
        isDescGenerating: false,
    },
    repopulate: false,
    pageType: {
        pages: [
            "Property Address",
            "Basic Property Details",
            "Property Features",
            "Generated Section",
        ],
        activePage: "Property Address",
    },
    popups: {
        busyServer: {
            show: false,
        },
    },
    errMsg: "Please fill the property address.",
};

const PropertyDescriptionReducer = (
    state = lodash.cloneDeep(INITIAL_STATE),
    action
) => {
    switch (action.type) {
        case AI_DESC_PD_CLEAR_PROP_DETAILS: {
            let temp_state = lodash.cloneDeep(INITIAL_STATE);
            temp_state.order_id = `${
                Date.now() + Math.floor(Math.random() * 100)
            }`;
            return { ...temp_state };
        }
        case AI_DESC_PD_SELECT_PROP_ADDRESS: {
            let temp_state = { ...state };
            temp_state["isAmenitiesLoading"] = true;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_UPDATE_PROP_ADDRESS: {
            const { propAdd } = action.payload;
            let temp_state = { ...state };
            if (temp_state["Property Address"] !== "") {
                temp_state = lodash.cloneDeep(INITIAL_STATE);
                temp_state.order_id = `${
                    Date.now() + Math.floor(Math.random() * 100)
                }`;
            }
            temp_state["Property Address"] = propAdd;
            temp_state["Property Details"].isGenDescBtnHidden = false;
            // Object.keys(temp_state["Nearby Amenities"]).forEach((amm) => {
            //     temp_state["Nearby Amenities"][amm]["isSelected"] = false;
            // });
            temp_state["Nearby Amenities"] = {};
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_FETCH_NEARBY_AMMENITIES: {
            const { ammenities } = action.payload;
            let temp_state = { ...state };
            temp_state["Property Details"].isGenDescBtnHidden = false;
            temp_state["Nearby Amenities"] = ammenities;
            temp_state["isAmenitiesLoading"] = false;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_UPDATE_NEARBY_AMMENITIES: {
            const { category, ammenity } = action.payload;
            let temp_state = { ...state };
            temp_state["Property Details"].isGenDescBtnHidden = false;
            temp_state["Nearby Amenities"][category][ammenity]["isSelected"] =
                !temp_state["Nearby Amenities"][category][ammenity][
                    "isSelected"
                ];
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_SHOW_OTHER_NEARBY_AMMENITIES_INPUT_FIELD: {
            const { isVisible } = action.payload;
            let temp_state = { ...state };
            temp_state["Property Details"].isGenDescBtnHidden = false;
            temp_state.isOtherNbaInputVisible = isVisible;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_FETCH_OTHER_NEARBY_AMMENITIES: {
            const { ammenity } = action.payload;
            let temp_state = { ...state };
            temp_state["Property Details"].isGenDescBtnHidden = false;
            // if(!temp_state["Nearby Amenities"].hasOwnProperty(ammenity)){
            //     temp_state["Other Nearby Amenities"][ammenity]={isSelected:true};
            // }
            temp_state["Nearby Amenities"][ammenity] = { isSelected: true };
            return {
                ...temp_state,
            };
        }
        // case AI_DESC_PD_UPDATE_OTHER_NEARBY_AMMENITIES: {
        //     const { ammenity } = action.payload;
        //     let temp_state = { ...state };
        //     temp_state["Property Details"].isGenDescBtnHidden = false;
        //     temp_state["Other Nearby Amenities"][ammenity]["isSelected"] =
        //         !temp_state["Other Nearby Amenities"][ammenity]["isSelected"];
        //     return {
        //         ...temp_state,
        //     };
        // }
        case AI_DESC_PD_UPDATE_PROP_TYPE: {
            const { propType } = action.payload;
            let temp_state = { ...state };
            temp_state["Property Details"].isGenDescBtnHidden = false;
            if (
                temp_state["Property Details"]["Property type"][
                    "defaultTitle"
                ] === propType
            ) {
                temp_state["Property Details"]["Property type"][
                    "selectedItem"
                ] = "";
                temp_state["Property Details"]["Property type"]["title"] =
                    temp_state["Property Details"]["Property type"][
                        "defaultTitle"
                    ];
            } else {
                temp_state["Property Details"]["Property type"][
                    "selectedItem"
                ] = propType;
                temp_state["Property Details"]["Property type"]["title"] =
                    propType;
            }

            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_ADD_PROP_FEAT: {
            const { featureType, subFeat, isPreDet, feature, preInd } =
                action.payload;
            let temp_state = { ...state };
            temp_state["Property Details"].isGenDescBtnHidden = false;
            let propFeat = lodash.get(
                temp_state["Property Details"],
                featureType,
                ""
            ).features[subFeat];
            if (preInd !== -1) {
                if (
                    propFeat?.selectedFeatures == "" ||
                    propFeat?.selectedFeatures.charAt(
                        propFeat?.selectedFeatures.trim().length - 1
                    ) == ","
                ) {
                    propFeat.selectedFeatures =
                        propFeat?.selectedFeatures.trim() + ` ${feature}`;
                } else {
                    propFeat.selectedFeatures =
                        propFeat?.selectedFeatures.trim() + `, ${feature}`;
                }
            } else {
                propFeat.selectedFeatures = feature;
            }

            let selectedFeats = propFeat.selectedFeatures
                .split(",")
                .map((str) => str.trim());
            propFeat["preDeterminedFeatures"].forEach((ft) => {
                if (selectedFeats.includes(ft.featureName)) {
                    ft.isSelected = true;
                } else {
                    ft.isSelected = false;
                }
            });
            // propFeat["preDeterminedFeatures"][preInd].isSelected=true
            dynamicFeat(temp_state);
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_REMOVE_PROP_FEAT: {
            const { featureType, subFeat, sftInd } = action.payload;
            let temp_state = { ...state };
            temp_state["Property Details"].isGenDescBtnHidden = false;
            // let propFeat = temp_state["Property Details"]["Property features"];
            let propFeat = lodash.get(
                temp_state["Property Details"],
                featureType,
                ""
            ).features[subFeat];
            let predetFeat =
                propFeat["preDeterminedFeatures"][sftInd].featureName;
            propFeat["preDeterminedFeatures"][sftInd].isSelected = false;
            let selectedFeaturesArr = propFeat?.selectedFeatures
                .split(",")
                .map((str) => str.trim());
            selectedFeaturesArr.splice(
                selectedFeaturesArr.indexOf(predetFeat),
                1
            );
            propFeat.selectedFeatures = selectedFeaturesArr.join(", ");
            // let preInd = propFeat[featureType][
            //     "preDeterminedFeatures"
            // ].findIndex((obj) => obj["featureName"] === feature);
            // propFeat[featureType]["selectedFeatures"].splice(sftInd, 1);
            // if (preInd !== -1) {
            //     propFeat[featureType]["preDeterminedFeatures"][preInd][
            //         "isSelected"
            //     ] = false;
            // }
            dynamicFeat(temp_state);
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_HANDLE_TOP_DROPDOWN_OPEN: {
            const { ddType, isOpen } = action.payload;
            let temp_state = { ...state };
            temp_state["Property Details"].isGenDescBtnHidden = false;
            // temp_state["Property Details"][ddType].isOpen = isOpen;
            let ddObj = lodash.get(temp_state["Property Details"], ddType, "");
            ddObj.isOpen = isOpen;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_UPDATE_DESIGN_TYPE: {
            const { designType } = action.payload;
            let temp_state = { ...state };
            temp_state["Property Details"].isGenDescBtnHidden = false;
            if (
                temp_state["Property Details"]["Design type"][
                    "defaultTitle"
                ] === designType
            ) {
                temp_state["Property Details"]["Design type"]["selectedItem"] =
                    "";
                temp_state["Property Details"]["Design type"]["title"] =
                    temp_state["Property Details"]["Design type"][
                        "defaultTitle"
                    ];
            } else {
                temp_state["Property Details"]["Design type"]["selectedItem"] =
                    designType;
                temp_state["Property Details"]["Design type"]["title"] =
                    designType;
            }
            // temp_state["Property Details"]["Design type"].selectedItem = designType;
            // temp_state["Property Details"]["Design type"].title=designType
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_UPDATE_PROP_ATT: {
            const { attType, val } = action.payload;
            let temp_state = { ...state };
            temp_state["Property Details"].isGenDescBtnHidden = false;
            let propAtt = temp_state["Property Details"]["Property Attributes"];
            // if(propAtt[attType]['inputType']==="number"){
            //     let inputVal=val
            //     inputVal=inputVal.replaceAll(",", "")
            //     if(propAtt[attType]?.isFloatAllowed){
            //         inputVal=Number(inputVal).toFixed(2)
            //     }else{
            //         inputVal=Number(inputVal)
            //     }
            //     propAtt[attType]["value"] = inputVal.toLocaleString();;
            // }else{
            if (propAtt[attType]["inputType"] === "dropDown") {
                if (
                    propAtt[attType]["ddObj"]["defaultTitle"] == val &&
                    propAtt[attType]["isRequired"] === false
                ) {
                    propAtt[attType]["ddObj"]["selectedItem"] = "";
                    propAtt[attType]["ddObj"]["title"] =
                        propAtt[attType]["ddObj"]["defaultTitle"];
                } else {
                    propAtt[attType]["ddObj"]["selectedItem"] = val;
                    propAtt[attType]["ddObj"]["title"] =
                        propAtt[attType]["ddObj"]["selectedItem"];
                }
                // propAtt[attType]["ddObj"]["isOpen"]=false
                propAtt[attType]["value"] =
                    propAtt[attType]["ddObj"]["selectedItem"];
            } else {
                propAtt[attType]["value"] = val;
            }
            // }

            if (attType === "Floors") {
                if (propAtt[attType]["value"] !== "01") {
                    let type =
                        temp_state["Property Details"].descriptionType
                            .selectedDescType;

                    if (type === "Floor-wise description") {
                        let tabs = [];
                        let floors = [
                            "Ground",
                            "Second",
                            "Third",
                            "Fourth",
                            "Fifth",
                        ];
                        let numberOfFloors =
                            temp_state["Property Details"][
                                "Property Attributes"
                            ]["Floors"].value;

                        for (let index = 0; index < numberOfFloors; index++) {
                            tabs.push(floors[index] + " floor");
                        }

                        tabs.push("General features");
                        temp_state["Property Details"].tabs.tabOptions = tabs;
                        temp_state["Property Details"].tabs.activeTab = tabs[0];
                        initializeTabData(
                            temp_state["Property Details"].tabs,
                            temp_state["Property Details"]["Property features"],
                            temp_state["Property Details"]["General features"]
                        );
                    }
                } else {
                    temp_state[
                        "Property Details"
                    ].descriptionType.selectedDescType =
                        "General comprehensive description";
                    let tabs = ["Home interior", "General features"];
                    temp_state["Property Details"].tabs.tabOptions = tabs;
                    temp_state["Property Details"].tabs.activeTab = tabs[0];
                    initializeTabData(
                        temp_state["Property Details"].tabs,
                        temp_state["Property Details"]["Property features"],
                        temp_state["Property Details"]["General features"]
                    );
                }
            }
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_UPDATE_PROP_ATT_DD_STATE: {
            const { isAttDdOpen, attType } = action.payload;
            let temp_state = { ...state };
            temp_state["Property Details"]["Property Attributes"][attType][
                "isOpen"
            ] = isAttDdOpen;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_UPDATE_PROP_ATT_DD_SELECT: {
            const { attType, ddContType } = action.payload;
            let temp_state = { ...state };
            temp_state["Property Details"].isGenDescBtnHidden = false;
            let propAtt = temp_state["Property Details"]["Property Attributes"];
            let ddCont = propAtt[attType]["dropdownContent"];
            let selected = "";
            Object.keys(ddCont).forEach((cont) => {
                ddCont[cont]["isSelected"] = false;
            });
            if (ddContType !== "Type") {
                ddCont[ddContType]["isSelected"] = true;
                selected = ddCont[ddContType]["lable"];
            } else {
                selected = "";
            }
            propAtt[attType]["unit"] = selected;
            // propAtt[attType]["isOpen"] = false;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_UPDATE_DESC_ISEDITING: {
            const { isEditing, descInd } = action.payload;
            let temp_state = { ...state };
            let propDesc = temp_state["Property Details"].descriptionGenerated;
            // let genDesc = propDesc[descInd]["description_generated"];
            // let edDesc = propDesc[descInd]["editedDesc"];
            // if (edDesc !== genDesc && edDesc!=="") {
            //     propDesc[descInd]["isEdited"] = true;
            // }else{
            //     propDesc[descInd]["isEdited"] = false;
            // }
            propDesc[descInd]["isEditing"] = isEditing;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_UPDATE_PAGE_TYPE: {
            const { pageNo } = action.payload;
            let temp_state = { ...state };
            temp_state.pageType.activePage = temp_state.pageType.pages[pageNo];
            temp_state.stepper.activeStepNo = pageNo;
            temp_state.stepper.activeStep =
                temp_state.stepper.steps[pageNo].title;
            temp_state.stepper.steps.forEach((step, i) => {
                step.active = pageNo === i ? true : false;
                step.completed = pageNo > i ? true : false;
            });
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_UPDATE_TAB: {
            const { tabNo } = action.payload;
            let temp_state = { ...state };
            temp_state["Property Details"].tabs.activeTab =
                temp_state["Property Details"].tabs.tabOptions[tabNo];
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_UPDATE_DESC: {
            const { descInd, desc } = action.payload;
            let temp_state = { ...state };
            let propDesc = temp_state["Property Details"].descriptionGenerated;
            propDesc[descInd]["editedDesc"] = desc;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_FETCH_DESC: {
            let temp_state = { ...state };
            const { descriptions } = action.payload;
            temp_state["Property Details"]["isGenDescBtnHidden"] = true;
            temp_state["Property Details"].descriptionGenerated = descriptions;
            let pageNo = 3;
            temp_state.pageType.activePage = temp_state.pageType.pages[pageNo];
            temp_state.stepper.steps.forEach((step, i) => {
                step.active = pageNo === i ? true : false;
                step.completed = pageNo >= i ? true : step.completed;
            });
            temp_state["Property Details"]["isDescGenerating"] = false;
            temp_state.repopulate = false;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_UPDATE_ACTION_DESC: {
            const { descInd, actionInfo, isEdited } = action.payload;
            let temp_state = { ...state };
            let propDesc = temp_state["Property Details"].descriptionGenerated;
            Object.keys(actionInfo).forEach((actKey) => {
                propDesc[descInd][actKey] = actionInfo[actKey];
            });
            propDesc[descInd]["isEdited"] = isEdited;
            propDesc[descInd]["isEditing"] = false;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_UNDO_DESC: {
            const { descInd } = action.payload;
            let temp_state = { ...state };
            let propDesc = temp_state["Property Details"].descriptionGenerated;
            propDesc[descInd]["editedDesc"] =
                propDesc[descInd]["description_generated"];
            propDesc[descInd]["isEditing"] = false;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_GENERATE_DESC: {
            let temp_state = { ...state };
            temp_state["Property Details"]["isDescGenerating"] = true;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_REGENERATE_DESC: {
            let temp_state = { ...state };
            temp_state["Property Details"]["isDescGenerating"] = true;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_HANDLE_REPOPULATE_PD: {
            const { data } = action.payload;
            let temp_state = { ...state };
            repopulate(temp_state, data);
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_HANDLE_UPDATE_DESC_TYPE: {
            const { type } = action.payload;
            let temp_state = { ...state };
            temp_state["Property Details"].descriptionType.selectedDescType =
                type;
            let tabs = [];
            let numberOfFloors =
                temp_state["Property Details"]["Property Attributes"]["Floors"]
                    .value;
            if (
                type === "General comprehensive description" ||
                numberOfFloors === ""
            ) {
                tabs = ["Home interior", "General features"];
            } else if (type === "Floor-wise description") {
                let floors = ["Ground", "Second", "Third", "Fourth", "Fifth"];

                for (let index = 0; index < numberOfFloors; index++) {
                    tabs.push(floors[index] + " floor");
                }

                tabs.push("General features");
            }
            temp_state["Property Details"].tabs.tabOptions = tabs;
            temp_state["Property Details"].tabs.activeTab = tabs[0];
            initializeTabData(
                temp_state["Property Details"].tabs,
                temp_state["Property Details"]["Property features"],
                temp_state["Property Details"]["General features"]
            );
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_UPDATE_TAB_DATA: {
            let temp_state = { ...state };
            const type =
                temp_state["Property Details"].descriptionType.selectedDescType;
            let tabs = [];
            let numberOfFloors =
                temp_state["Property Details"]["Property Attributes"]["Floors"]
                    .value;
            if (
                type === "General comprehensive description" ||
                numberOfFloors === ""
            ) {
                tabs = ["Home interior", "General features"];
            } else if (type === "Floor-wise description") {
                let floors = ["Ground", "Second", "Third", "Fourth", "Fifth"];

                for (let index = 0; index < numberOfFloors; index++) {
                    tabs.push(floors[index] + " floor");
                }

                tabs.push("General features");
            }
            temp_state["Property Details"].tabs.tabOptions = tabs;
            temp_state["Property Details"].tabs.activeTab = tabs[0];
            initializeTabData(
                temp_state["Property Details"].tabs,
                temp_state["Property Details"]["Property features"],
                temp_state["Property Details"]["General features"]
            );
            return {
                ...temp_state,
            };
        }
        case AI_DESC_PD_HANDLE_SEVER_BUSY_POPUP: {
            let temp_state = { ...state };
            const { isShow } = action.payload;
            temp_state.popups.busyServer.show = isShow;
            return {
                ...temp_state,
            };
        }
        default:
            return state;
    }
};

export default PropertyDescriptionReducer;
